import React from 'react';

import { useTranslation } from 'react-i18next';

import { LANDING_HEALTH_REPORT_ROUTE } from '../../../../../../constants/auth';
import { CLIENTS_PORTAL_URL } from '../../../../../../constants/constants';
import { OUT_ICON } from '../../../../../../constants/images';
import { CLICK_ACTION, VIEW_HEALTH_REPORT } from '../../../../../../constants/tagManager';
import { IHealthReportList } from '../../../../../../interfaces/reports';
import TagManagerService from '../../../../../../services/gtm/tagManagerService';
import { TRANSLATIONS_REPORTS } from '../../../../../../translations/reports';
import { toLocalStorage } from '../../../../../../utils/utils';
import BdsTooltip from '../../../../BdsTooltip/BdsTooltip';
import BdsIconButton from '../../../../Buttons/BdsIconButton/BdsIconButton';

interface IHealthReportsTableActionsProps {
  report: IHealthReportList;
  disabled?: boolean;
}

export const HealthReportsTableActions = ({ report, disabled }: IHealthReportsTableActionsProps) => {
  const { t } = useTranslation();

  const onClick = () => {
    TagManagerService.pushEvent(CLICK_ACTION, VIEW_HEALTH_REPORT);
    toLocalStorage('reportData', JSON.stringify(report));
    window.open(CLIENTS_PORTAL_URL + LANDING_HEALTH_REPORT_ROUTE, '_blank');
  };

  const renderIconButton = () => (
    <BdsIconButton
      icon={OUT_ICON}
      variant="transparent"
      size="sm"
      action={onClick}
      className="reports-table-actions__button"
      disabled={disabled}
    />
  );

  return (
    <>
      {disabled ? (
        <BdsTooltip message={t(TRANSLATIONS_REPORTS.table.tooltipWeb)} position="left" className="text-start">
          {renderIconButton()}
        </BdsTooltip>
      ) : (
        renderIconButton()
      )}
    </>
  );
};

export default HealthReportsTableActions;
